var map = {
	"./architecture-highlights.md": 104,
	"./bath-dungeon-of-doom.md": 105,
	"./bath-srpn.md": 106,
	"./codaisseur-project-cowbell.md": 107,
	"./first-ever-website.md": 108,
	"./osu-collection-manipulator.md": 109,
	"./portfolio-website.md": 110,
	"./questionnaires-appjection.md": 111,
	"./semicolon-spammer.md": 112,
	"./week7-bomberman-game.md": 113,
	"./week8-ticket-uber-fullstack.md": 114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 103;